export default __webpack_public_path__ + "static/media/logo888.680d7a19.png";